/**
 * t449u: where Sign in goes afterwards. Emailed links open on the workspace's own address; signed out, the app sends
 * you to /signin?next=<the link> and back there after signing in. Only paths in this app (never another site), and
 * kept across the Microsoft sign-in round trip, which returns to the site's home page.
 */
const KEY = 'hub.signin.next';

export function safeNext(raw: string | null | undefined): string {
  const v = (raw ?? '').trim();
  return v.startsWith('/') && !v.startsWith('//') && !v.startsWith('/\\') && !v.startsWith('/signin') ? v : '/';
}

export function rememberNext(next: string) {
  try { if (safeNext(next) !== '/') sessionStorage.setItem(KEY, safeNext(next)); else sessionStorage.removeItem(KEY); } catch { /* private mode */ }
}

/** The remembered path (once), or null. */
export function takeRememberedNext(): string | null {
  try { const v = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); return v ? safeNext(v) : null; } catch { return null; }
}
